/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { Component, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AccessType, WithMember } from "@quintype/components";
import get from "lodash/get";
import "./user-details.m.css";
import { UserProfile } from "./user-profile";
import { SubscriptionsBlock } from "./subscription-details";
import { PurchasedStoriesBlock } from "./purchase-stories";
import LoaderOverlay from "../../molecules/loader-overlay";
import { parseBool } from "../../../utils";

const InfoMeassage = ({ openLoginTemplate }) => {
  return (
    <div styleName="info-message-wrapper">
      <h3>You must sign in to access this page.</h3>
      <div styleName="button" onClick={openLoginTemplate}>
        Sign In
      </div>
    </div>
  );
};

InfoMeassage.propTypes = {
  openLoginTemplate: PropTypes.func
};

const UserContent = ({
  enableAccesstype,
  currentScreen,
  isAccessTypeLoaded,
  member,
  getSubscriptionForUser,
  loadSubscriptionMenu
}) => {
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const [isSubscriptionsLoading, setIsSubscriptionsLoading] = useState(true);

  const getUserSubscriptions = async () => {
    const { subscriptions } = (await getSubscriptionForUser()) || [];
    setIsSubscriptionsLoading(false);
    loadSubscriptionMenu(true);
    subscriptions && setUserSubscriptions(subscriptions);
  };

  useEffect(() => {
    enableAccesstype && isAccessTypeLoaded && !userSubscriptions.length && getUserSubscriptions();
    !enableAccesstype && setIsSubscriptionsLoading(false);
  }, [isAccessTypeLoaded, currentScreen, enableAccesstype]);

  switch (currentScreen) {
    case "Profile":
      return (
        <UserProfile
          subscriptions={userSubscriptions}
          isSubscriptionsLoading={isSubscriptionsLoading}
          member={member}
          enableAccesstype={enableAccesstype}
        />
      );
    case "Subscription":
      return <SubscriptionsBlock subscriptions={userSubscriptions} />;
    case "PurchasedStories":
      return <PurchasedStoriesBlock subscriptions={userSubscriptions} />;
    default:
      return null;
  }
};

UserContent.propTypes = {
  isAccessTypeLoaded: PropTypes.bool,
  enableAccesstype: PropTypes.bool,
  getSubscriptionForUser: PropTypes.func,
  member: PropTypes.object,
  subscriptions: PropTypes.arrayOf(PropTypes.object),
  currentScreen: PropTypes.string,
  loadSubscriptionMenu: PropTypes.func
};

const userMenu = (enableAccesstype, enablePayPerAsset, enableSubscriptionMenu) => {
  return [
    {
      name: "Profile",
      label: "Profile",
      active: "true"
    },
    {
      name: "Subscription",
      label: "Subscription",
      active: enableAccesstype && enableSubscriptionMenu
    },
    {
      name: "PurchasedStories",
      label: "Purchased Stories",
      active: enablePayPerAsset && enableSubscriptionMenu
    }
  ];
};

class UserDetailsBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      currentScreen: "Profile",
      enableSubscriptionMenu: false
    };
    this.loadSubscriptionMenu = this.loadSubscriptionMenu.bind(this);
  }

  loadSubscriptionMenu = () => {
    this.setState({ enableSubscriptionMenu: true });
  };

  handleClick = (currentScreen, index) => {
    this.setState({ activeIndex: index });
    this.setState({ currentScreen });
  };

  render() {
    return (
      <WithMember>
        {({ member, isLoading: isMemberLoading }) => {
          if (isMemberLoading) return <LoaderOverlay />;
          if (!isMemberLoading && !member) return <InfoMeassage openLoginTemplate={this.props.openLoginTemplate} />;
          const { email = "", "phone-number": phone = "" } = member;
          const themeAttributes = get(this.props, ["config", "theme-attributes"]);
          const PbAccessTypeConfig = get(this.props, [
            "config",
            "pagebuilder-config",
            "general",
            "accesstypeIntegration"
          ]);
          const accessTypeKey = get(PbAccessTypeConfig, ["accesstypeKey"], get(themeAttributes, ["accesstypeKey"]));
          const accessTypeBkIntegrationId = get(
            PbAccessTypeConfig,
            ["bridgeKeeperIntegrationId"],
            get(themeAttributes, ["accesstypeBkIntegrationId"], "")
          );
          const isStaging =
            get(PbAccessTypeConfig, ["accesstypeMode"]) === "staging" ||
            get(themeAttributes, ["accesstypeEnvironment"]) === "staging";

          const enableAccesstype = get(
            PbAccessTypeConfig,
            ["enableAccesstype"],
            get(themeAttributes, ["enableAccesstype"], false)
          );
          const disableMetering = get(
            PbAccessTypeConfig,
            ["disableMetering"],
            get(themeAttributes, ["disableMetering"]) === "true"
          );
          const enablePayPerAsset = get(
            PbAccessTypeConfig,
            ["enablePayPerAsset"],
            get(themeAttributes, ["enablePayPerAsset"], false)
          );

          const isAccessTypeEnabled = parseBool(enableAccesstype);
          const isPayPerAssetEnabled = isAccessTypeEnabled && parseBool(enablePayPerAsset);

          return (
            <div styleName="user-detail-wrapper ">
              <div styleName="placeholder-components">
                {userMenu(isAccessTypeEnabled, isPayPerAssetEnabled, this.state.enableSubscriptionMenu).map(
                  (menu, index) => {
                    return (
                      <div
                        key={menu.name}
                        styleName={this.state.activeIndex === index ? "active-comp placeholder" : "placeholder"}
                        onClick={() => this.handleClick(menu.name, index)}
                      >
                        {menu.active && <span styleName="name">{menu.label}</span>}
                      </div>
                    );
                  }
                )}
              </div>

              <div styleName="linked-components">
                <AccessType
                  enableAccesstype={isAccessTypeEnabled}
                  isStaging={isStaging}
                  accessTypeKey={accessTypeKey}
                  accessTypeBkIntegrationId={accessTypeBkIntegrationId}
                  email={email}
                  phone={phone}
                  disableMetering={parseBool(disableMetering)}
                >
                  {({ getSubscriptionForUser }) => {
                    return (
                      <UserContent
                        enableAccesstype={isAccessTypeEnabled}
                        member={member}
                        currentScreen={this.state.currentScreen}
                        getSubscriptionForUser={getSubscriptionForUser}
                        isAccessTypeLoaded={!!global.AccessType} // TODO: AT should provide this flag
                        loadSubscriptionMenu={this.loadSubscriptionMenu}
                      />
                    );
                  }}
                </AccessType>
              </div>
            </div>
          );
        }}
      </WithMember>
    );
  }
}

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"])
});
const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" })
});

UserDetailsBase.propTypes = {
  config: PropTypes.shape({
    "theme-attributes": PropTypes.object
  }),
  openLoginTemplate: PropTypes.func
};

const UserDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDetailsBase);

export { UserDetails };
